import React from "react";
import PricingGrid from "../Pricing/PriceGrid";
const darkcolors = ["Red", "Black"]
export default function pricingSegment({ segment }) {
  return (
    <div className="segment pricingSegment" style={{ backgroundColor: segment.segstyle?.bg.value }}>
      <PricingGrid />
    </div>
  )
}